import axios from "axios";

const state = () => ({
  filterOptions: {
    courses: [],
    deviceClass: [],
  },
  loading: false,
});

const mutations = {
  SET_FILTER_OPTIONS(state, courses) {
    state.filterOptions = courses;
  },
  RESET_FILTER_OPTIONS(state) {
    state.filterOptions = {
      courses: [],
      deviceClass: [],
    };
  },
  SET_LOADING(state) {
    state.loading = true;
  },
  CLEAR_LOADING(state) {
    state.loading = false;
  },
};

const getters = {
  getFilterOptions: (state) => {
    return state.filterOptions;
  },
  getLoading: (state) => {
    return state.loading;
  },
};

const actions = {
  async fetchFilterOptions({ commit }) {
    commit("SET_LOADING");
    const url = process.env.VUE_APP_API_URL + "/devices/filter";

    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_FILTER_OPTIONS", response.data);
      commit("CLEAR_LOADING");
    } catch (error) {
      console.log(error);
      commit("CLEAR_LOADING");
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
